export { Transition } from "@mantine/core";
export type { TransitionProps } from "@mantine/core";
